import React, { useContext, useEffect, useRef, useState } from "react";
import { Edit, Save, Cancel } from "@mui/icons-material";
import {
  IconButton,
  TextField,
  FormControlLabel,
  Switch,
  MenuItem,
  Dialog,
  DialogContent,
} from "@mui/material";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { ThemeContext } from "../../../context/themeProviderContext";
import AuthAPI, { UyelikGuncelleRequest } from "../../../apis/AuthAPI";
import MahalleListeAPI from "../../../apis/OB/Get/MahalleListeAPI";
import CaddeSokakAPI from "../../../apis/OB/Get/CaddeSokakAPI";
import IlIlceListeAPI from "../../../apis/OB/Get/IlIlceListeAPI";
import SessionStorageService from "../../../services/StorageService";
import { safelyParseNumber, sortDataByField } from "../../../helpers/MoneyFormat";
import TcTelefonSmsControlPopupOnPage from "../../../components/OB/popups/popup-tel-dogrulama";
import { showToast } from "../../../helpers/ToastifyHelper";
import KullaniciYonetimi, { KullaniciGetRequest, KullaniciAdresGetRequest } from "../../../apis/KullaniciYonetimi";

interface ProfileProps {
  isAdminEdit?: boolean;
  userId?: number;
  onClose?: () => void;
}

export const Profile = ({ isAdminEdit = false, userId, onClose }: ProfileProps) => {
  const user = !isAdminEdit ? SessionStorageService.getUserInfo() : null;
  const [adminUser, setAdminUser] = useState<any>(null);
  const [adminAddress, setAdminAddress] = useState<any>(null);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const recaptchaTokenRef: any = useRef();
  const [handleRecaptchaChange, setHandleRecaptchaChange] = useState(false);
  const getRecaptchaTokenRef = () => {
    return recaptchaTokenRef.current?.handleSubmit();
  };

  const [mahalleList, setMahalleList] = useState<any[]>([]);
  const [ilIlceList, setIlIlceList] = useState<any[]>([]);
  const {ilIlceKodu}:any=useContext(ThemeContext)
  console.log("ılılcekodu",ilIlceKodu)
  const [caddeSokakList, setCaddeSokakList] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  // State: Edit Modu ve Form Bilgileri
  const [isEditMode, setIsEditMode] = useState(false);
  const [editModeInitialized, setEditModeInitialized] = useState(false);

  // Form verilerini güncellemek için useEffect
  useEffect(() => {
    if (isAdminEdit && adminUser && adminAddress) {
      setFormData({
        sqId: adminUser.sqId || "",
        adi: adminUser.adi || "",
        soyadi: adminUser.soyadi || "",
        cepTelefon: adminUser.cepTelefon || "",
        ePosta: adminUser.ePosta || "",
        mahalleKodu: adminAddress.rfOrtMahalleKoyler || "",
        caddeSokakKodu: adminAddress.rfOrtCaddeSokak || "",
        mahalleAdi: adminAddress.mahalleAdi || "",
        caddeAdi: adminAddress.caddeAdi || "",
        kapiNo: adminAddress.kapiNo || "",
        daireNo: adminAddress.daireNo || "",
        siteApartmanAdi: adminAddress.siteApartmanAdi || "",
        blokNo: adminAddress.blokNo || "",
        postaKodu: adminAddress.postaKodu || "",
        smsBilgilendirme: adminUser.smsBilgilendirme === "E",
        mailBilgilendirme: adminUser.mailBilgilendirme === "E",
        kanGrubu: adminUser.kanGrubu || "",
        ilIlceKodu: adminAddress.ilIlceKodu || "",
        rol: adminUser.rol || "",
      });
    }
  }, [isAdminEdit, adminUser, adminAddress]);

  const initialFormData = {
    sqId: isAdminEdit ? adminUser?.sqId : user?.sqId || "",
    adi: isAdminEdit ? adminUser?.adi : user?.adi || "",
    soyadi: isAdminEdit ? adminUser?.soyadi : user?.soyadi || "",
    cepTelefon: isAdminEdit ? adminUser?.cepTelefon : user?.cepTelefon || "",
    ePosta: isAdminEdit ? adminUser?.ePosta : user?.ePosta || "",
    mahalleKodu: isAdminEdit ? adminUser?.rfOrtMahalleKoyler : user?.rfOrtMahalleKoyler || "",
    caddeSokakKodu: isAdminEdit ? adminUser?.rfOrtCaddeSokak : user?.rfOrtCaddeSokak || "",
    mahalleAdi: isAdminEdit ? adminUser?.mahalleAdi : user?.mahalleAdi || "",
    caddeAdi: isAdminEdit ? adminUser?.caddeAdi : user?.caddeAdi || "",
    kapiNo: isAdminEdit ? adminUser?.kapiNo : user?.kapiNo || "",
    daireNo: isAdminEdit ? adminUser?.daireNo : user?.daireNo || "",
    siteApartmanAdi: isAdminEdit ? adminUser?.siteApartmanAdi : user?.siteApartmanAdi || "",
    blokNo: isAdminEdit ? adminUser?.blokNo : user?.blokNo || "",
    postaKodu: isAdminEdit ? adminUser?.postaKodu : user?.postaKodu || "",
    smsBilgilendirme: isAdminEdit ? adminUser?.smsBilgilendirme === "E" : user?.smsBilgilendirme === "E",
    mailBilgilendirme: isAdminEdit ? adminUser?.mailBilgilendirme === "E" : user?.mailBilgilendirme === "E",
    kanGrubu: isAdminEdit ? adminUser?.kanGrubu : user?.kanGrubu || "",
    ilIlceKodu: isAdminEdit ? adminUser?.ilIlceKodu : user?.ilIlceKodu || "",
    rol: isAdminEdit ? adminUser?.rol : user?.rol || "",
  };
  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === "cepTelefon" && value.length === 10) {
      const formattedValue = `${value.slice(0, 3)} ${value.slice(
        3,
        6
      )} ${value.slice(6)}`;
      setFormData((prevData) => ({
        ...prevData,
        [name]: formattedValue,
      }));
    }
  };

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    const { name } = e.target;
    if (name === "cepTelefon") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: prevData[name].replace(/\s/g, ""),
      }));
    }
  };
  const navigate = useNavigate();
  const saveYeniUyelik = async (formData: any) => {
    const captchaToken = getRecaptchaTokenRef();

    try {
      const telefon = formData.cepTelefon.replace(/\s/g, "");
      if (telefon.length !== 10 || isNaN(Number(telefon))) {
        toast.error("Telefon numarası geçerli değil.");
        return;
      }

      const request: UyelikGuncelleRequest = {
        adresSqId: isAdminEdit ? adminAddress?.sqId : user?.adresSqId,
        blokNo: formData.blokNo,
        caddeSokakAdi: formData.caddeAdi,
        caddeSokakKodu: formData.caddeSokakKodu !== "" ? formData.caddeSokakKodu : undefined,
        daireNo: formData.daireNo,
        ePosta: formData.ePosta,
        guncelleyen:  isAdminEdit ? SessionStorageService.getUserInfo().adi:user?.adi,
        kanGrubu: formData.kanGrubu,
        kapiNo: formData.kapiNo,
        mahalleAdi: formData.mahalleAdi,
        kullaniciId: isAdminEdit ? userId : user?.sqId,
        mahalleKodu: formData.mahalleKodu !== "" ? formData.mahalleKodu : undefined,
        postaKodu: safelyParseNumber(formData.postaKodu) ?? undefined,
        telefon: Number(telefon),
        siteApartmanAdi: formData.siteApartmanAdi,
        ilIlceKodu: formData.ilIlceKodu ? formData.ilIlceKodu.toString() : "",
        rol: (isAdminEdit && SessionStorageService.getUserInfo().rol === "ADMIN") ? formData.rol : undefined,
      };
      console.log(request)
      const response = await AuthAPI.ProfilGuncelleme(request);
      if (response.data.sonuc === 0 && response.success) {
        toast.success("Güncelleme başarılı.");
        setIsEditMode(false);
        if (isAdminEdit && onClose) {
          onClose();
        }
      } else {
        toast.error("Kayıt başarısız: " + response.data.sonucAciklama);
        recaptchaTokenRef.current?.reset();
      }
    } catch (error) {
      toast.error("API hatası: " + error);
      recaptchaTokenRef.current?.reset();
      console.error("API hatası:", error);
    }
  };
  const [formData, setFormData] = useState(initialFormData);
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);
  useEffect(() => {
    async function fetchIlIlceler() {
      const response = await IlIlceListeAPI.getIlIlceListe(undefined);
      let orderedData:any=[]
      if(response.data.length>0){
        orderedData=sortDataByField(response.data,"ilIlceAdi")
      }
      setIlIlceList(orderedData || []);

      // İlk yüklemede il/ilçe eşleştirme
      if (isInitialLoad && orderedData.length > 0) {
        const matchedIlce = orderedData.find(
          (item:any) => String(item.ilIlceKodu) === String(formData.ilIlceKodu)
        );
        if (matchedIlce) {
          setFormData((prevData) => ({
            ...prevData,
            ilIlceKodu: matchedIlce.ilIlceKodu,
          }));
        }
      }
    }
    fetchIlIlceler();
  }, [isInitialLoad]);

  // API'den mahalle listesini çek ve default değer ile eşleştir
  useEffect(() => {
    async function fetchMahalleler() {
      const response = await MahalleListeAPI.getMahalleListe(undefined,undefined);
      let orderedData:any=[]
      if(response.data.length>0){
        orderedData=sortDataByField(response.data,"mahalleAdi")
      }
      setMahalleList(orderedData);

      // İlk yüklemede mahalle eşleştirme
      if (isInitialLoad && orderedData.length > 0) {
        const matchedMahalle:any = orderedData.find(
          (item:any) => String(item.mahalleKodu) === String(formData.mahalleKodu)
        );
        if (matchedMahalle) {
          setFormData((prevData) => ({
            ...prevData,
            mahalleKodu: matchedMahalle.mahalleKodu,
          }));
        }
      }
    }
    fetchMahalleler();
  }, [isInitialLoad]);
  const [secilenIlIlce,setSecilenIlIlce]=useState<any>("")
  useEffect(() => {
    if (formData.ilIlceKodu) {
      setSecilenIlIlce(formData.ilIlceKodu);
      console.log("secilen ililce",formData.ilIlceKodu)
    }
  }, [formData.ilIlceKodu]);
  // İlk yüklemenin tamamlandığını işaretle
  useEffect(() => {
    if (ilIlceList.length > 0 && mahalleList.length > 0) {
      setIsInitialLoad(false);
    }
  }, [ilIlceList, mahalleList]);
  useEffect(() => {
    // İl/ilçe listesi yüklendikten sonra kullanıcı verisini eşleştir
    if (ilIlceList.length > 0 ) {
      const matchingIlIlce:any = ilIlceList.find(
        (item: any) => String(item.ilIlceKodu) === String(formData.ilIlceKodu)
      );
      console.log("matchin iliçe",matchingIlIlce)
      // Eğer eşleşen il/ilçe bulunursa formData güncellenir
      if (matchingIlIlce) {
        setFormData((prevData) => ({
          ...prevData,
          ilIlceKodu: matchingIlIlce.ilIlceKodu, // Varsayılan değer
        }));
      } else {
        console.warn("İl/ilçe kodu eşleşmedi:", formData.ilIlceKodu);
      }
    }
  }, [ilIlceList]);

  const [errors, setErrors] = useState<any>({
    adi: false,
    soyadi: false,
    cepTelefon: false,
    ePosta: false,
    mahalleKodu: false,
    caddeSokakKodu: false,
    kapiNo: false,
    daireNo: false,
    smsBilgilendirme: false,
    mailBilgilendirme: false,
    ilIlceKodu:false
  });
  const validateForm = () => {
    const cleanedCepTelefon = formData.cepTelefon.replaceAll(" ", ""); // Telefon numarasını boşluklardan temizle

    const newErrors: any = {
      adi: !formData.adi.trim(),
      soyadi: !formData.soyadi.trim(),
      cepTelefon: !cleanedCepTelefon || cleanedCepTelefon.length !== 10, // Uzunluk kontrolü ekleniyor
      ePosta: !formData.ePosta.trim(),

      // Eğer secilenIlIlce, belirli bir il koduna eşitse mahalleKodu ve caddeKodu zorunlu
      // Değilse mahalleAdi ve caddeAdi zorunlu
      mahalleKodu:
        secilenIlIlce === ilIlceKodu && (!formData.mahalleKodu || formData.mahalleKodu === ""),
      mahalleAdi:
        secilenIlIlce !== ilIlceKodu && (!formData.mahalleAdi || formData.mahalleAdi.trim() === ""),

      caddeSokakKodu:
        secilenIlIlce === ilIlceKodu && (!formData.caddeSokakKodu || formData.caddeSokakKodu === ""),
      caddeAdi:
        secilenIlIlce !== ilIlceKodu && (!formData.caddeAdi || formData.caddeAdi.trim() === ""),

      kapiNo: !formData.kapiNo.trim(),
      daireNo: !formData.daireNo.trim(),
      ilIlceKodu: !formData.ilIlceKodu || formData.ilIlceKodu === "",
    };

    setErrors(newErrors);

    return Object.values(newErrors).every((error) => !error);
  };
  useEffect(() => {
    if (formData.mahalleKodu) {
      const fetchCaddeSokaklar = async () => {
        const response = await CaddeSokakAPI.getCaddeSokakListe(undefined, formData.mahalleKodu);
        let orderedData: any[] = [];
        if (response.data.length > 0) {
          orderedData = sortDataByField(response.data, "caddeSokakAdi");
        }
        setCaddeSokakList(orderedData || []);

        // Cadde kodunu kontrol et: kod geçerliyse koru, değilse caddeAdi ile eşleştirmeyi dene
        setFormData((prevData) => {
          // Önce mevcut kod geçerli mi kontrol et
          const isValidCadde = orderedData.some(
            (cadde: any) => String(cadde.caddeSokakKodu) === String(prevData.caddeSokakKodu)
          );
          if (isValidCadde) {
            return { ...prevData };
          }

          // Kod geçerli değilse, caddeAdi ile eşleştirmeyi dene
          if (prevData.caddeAdi) {
            const matchedCadde = orderedData.find(
              (cadde: any) => String(cadde.caddeSokakAdi) === String(prevData.caddeAdi)
            );
            if (matchedCadde) {
              return {
                ...prevData,
                caddeSokakKodu: matchedCadde.caddeSokakKodu,
              };
            }
          }

          // Hiçbiri eşleşmezse ve ilk yükleme değilse sıfırla
          if (!isInitialLoad) {
            return { ...prevData, caddeSokakKodu: "", caddeAdi: "" };
          }
          return { ...prevData, caddeSokakKodu: "" };
        });
      };
      fetchCaddeSokaklar();
    } else {
      setCaddeSokakList([]);
      setFormData((prevData) => ({
        ...prevData,
        caddeSokakKodu: "",
        caddeAdi: prevData.caddeAdi,
      }));
    }
  }, [formData.mahalleKodu]);

  useEffect(() => {
    if (caddeSokakList.length > 0 && formData.caddeSokakKodu) {
      const isValidCadde = caddeSokakList.some(
        (cadde: any) => String(cadde.caddeSokakKodu) === String(formData.caddeSokakKodu)
      );
      if (isValidCadde) {
        setFormData((prevData) => ({
          ...prevData,
          caddeSokakKodu: prevData.caddeSokakKodu,
        }));
      }
    }
  }, [caddeSokakList]);

  useEffect(() => {
    // formData değiştiğinde başlangıç form verileri ile karşılaştır
    const isChanged =
      JSON.stringify(formData) !== JSON.stringify(initialFormData);
    setIsSaveEnabled(isChanged);
  }, [formData]);

  // Form Değerlerini Güncelleme
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Switch Değişikliği için

  // Kaydet ve İptal İşlemleri
  const handleSave = async () => {
    if (validateForm()) {
      if (isAdminEdit) {
        // Admin edit modunda direkt kaydet
        saveYeniUyelik(formData);
      } else {
        // Normal kullanıcı modunda SMS doğrulama yap
        setSmsPopupOpen(true);
      }
    }
  };

  // SMS doğrulama süreci

  const handleCancel = () => {
    if (isAdminEdit && adminUser && adminAddress) {
      setFormData({
        sqId: adminUser.sqId || "",
        adi: adminUser.adi || "",
        soyadi: adminUser.soyadi || "",
        cepTelefon: adminUser.cepTelefon || "",
        ePosta: adminUser.ePosta || "",
        mahalleKodu: adminAddress.rfOrtMahalleKoyler || "",
        caddeSokakKodu: adminAddress.rfOrtCaddeSokak || "",
        mahalleAdi: adminAddress.mahalleAdi || "",
        caddeAdi: adminAddress.caddeAdi || "",
        kapiNo: adminAddress.kapiNo || "",
        daireNo: adminAddress.daireNo || "",
        siteApartmanAdi: adminAddress.siteApartmanAdi || "",
        blokNo: adminAddress.blokNo || "",
        postaKodu: adminAddress.postaKodu || "",
        smsBilgilendirme: adminUser.smsBilgilendirme === "E",
        mailBilgilendirme: adminUser.mailBilgilendirme === "E",
        kanGrubu: adminUser.kanGrubu || "",
        ilIlceKodu: adminAddress.ilIlceKodu || "",
        rol: adminUser.rol || "",
      });
    } else {
      setFormData({
        sqId: user?.sqId || "",
        adi: user?.adi || "",
        soyadi: user?.soyadi || "",
        cepTelefon: user?.cepTelefon || "",
        ePosta: user?.ePosta || "",
        mahalleKodu: user?.rfOrtMahalleKoyler || "",
        caddeSokakKodu: user?.rfOrtCaddeSokak || "",
        mahalleAdi: user?.mahalleAdi || "",
        caddeAdi: user?.caddeAdi || "",
        kapiNo: user?.kapiNo || "",
        daireNo: user?.daireNo || "",
        siteApartmanAdi: user?.siteApartmanAdi || "",
        blokNo: user?.blokNo || "",
        postaKodu: user?.postaKodu || "",
        smsBilgilendirme: user?.smsBilgilendirme === "E",
        mailBilgilendirme: user?.mailBilgilendirme === "E",
        kanGrubu: user?.kanGrubu || "",
        ilIlceKodu: user?.ilIlceKodu || "",
        rol: user?.rol || "",
      });
    }
    setIsEditMode(false);
  };
  const [smsPopupOpen, setSmsPopupOpen] = useState(false); // Popup açık mı?
  const [isSmsVerified, setIsSmsVerified] = useState(false); // Doğrulama tamamlandı mı?
  useEffect(() => {
    if (!isInitialLoad && formData.ilIlceKodu) {
      setSecilenIlIlce(formData.ilIlceKodu);
    }
  }, [formData.ilIlceKodu, isInitialLoad]);
  useEffect(() => {
    if (!isInitialLoad) {
      setLoading(false);
    }
  }, [isInitialLoad]);

  useEffect(() => {
    if (isAdminEdit && userId) {
      // Fetch user data for admin edit
      const fetchUserData = async () => {
        try {
          const [userResponse, addressResponse] = await Promise.all([
            KullaniciYonetimi.kullaniciGet(new KullaniciGetRequest({kullaniciId: userId})),
            KullaniciYonetimi.kullaniciAdresGet(new KullaniciAdresGetRequest({kullaniciId: userId}))
          ]);

          setAdminUser(userResponse.data);
          if (addressResponse.data && addressResponse.data.length > 0) {
            setAdminAddress(addressResponse.data[0]);
          }

        } catch (error) {
          console.error("Error fetching user data:", error);
          showToast("Kullanıcı bilgileri alınırken bir hata oluştu.", "error");
        }
      };
      fetchUserData();
    }
  }, [isAdminEdit, userId]);

  // Cadde listesi ve edit mode aktifken, seçili cadde kodunu tekrar set et
  useEffect(() => {
    if (
      isEditMode &&
      !editModeInitialized &&
      formData.mahalleKodu &&
      (secilenIlIlce !== ilIlceKodu || caddeSokakList.length > 0)
    ) {
      setFormData((prevData) => ({
        ...prevData,
        mahalleKodu: prevData.mahalleKodu,
        caddeSokakKodu: prevData.caddeSokakKodu,
      }));
      setEditModeInitialized(true);
    }
  }, [isEditMode, editModeInitialized, formData.mahalleKodu, caddeSokakList, secilenIlIlce, ilIlceKodu]);

  useEffect(() => {
    if (!isEditMode) {
      setEditModeInitialized(false);
    }
  }, [isEditMode]);

  if (!isAdminEdit && !user) {
    return <div className="text-center">Kullanıcı bilgisi bulunamadı.</div>;
  }
  if (isAdminEdit && !adminUser) {
    return <div className="text-center">Kullanıcı bilgileri yükleniyor...</div>;
  }
  if (loading) {
    return <div>Loading...</div>;
  }
  return (
    <div className={isAdminEdit ? "" :  "container mt-4"}>
      <h2 className="text-center mb-4">
        {isAdminEdit ? "Kullanıcı Bilgilerini Düzenle" : "Kullanıcı Bilgilerim"}
      </h2>
      <hr />
      <div className="card p-4 mb-5">
        <div className="d-flex justify-content-end mb-3">
          {!isEditMode ? (
            <IconButton
              onClick={() => {
                if (
                  mahalleList.length > 0 &&
                  (formData.mahalleKodu || formData.mahalleAdi) &&
                  (secilenIlIlce !== ilIlceKodu || caddeSokakList.length > 0)
                ) {
                  setTimeout(() => {
                    setIsEditMode(true);
                  }, 1000);
                } else {
                  // alert("Adres verileri yükleniyor, lütfen bekleyin.");
                }
              }}
            >
              <Edit />
            </IconButton>
          ) : (
            <div>
              <IconButton onClick={handleSave} disabled={!isSaveEnabled}>
                <Save />
              </IconButton>

              <IconButton onClick={handleCancel}>
                <Cancel />
              </IconButton>
            </div>
          )}
        </div>

        <div className="row">
          {/* Kullanıcı Bilgileri */}
          <div className="col-md-6 mb-3">
            <h5 className="fw-bold mb-3">Kullanıcı Bilgileri</h5>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">
                <strong className="me-2">TC Kimlik No:</strong>{" "}
                {isAdminEdit ? adminUser?.kullaniciKodu : user?.kullaniciKodu}
              </li>
              <li className="list-group-item">
                <strong className="me-2">Doğum Tarihi:</strong>{" "}
                {isAdminEdit ? new Date(adminUser?.dogumTarihi).toLocaleDateString("tr-TR") : new Date(user.dogumTarihi).toLocaleDateString("tr-TR")}
              </li>
              <li className="list-group-item">
                <strong className="me-2">Ad:</strong>
                {formData.adi}
              </li>
              <li className="list-group-item">
                <strong className="me-2">Soyad:</strong>
                {formData.soyadi}
              </li>

              <li className="list-group-item">
                {isEditMode ? null : <strong className="me-2">Telefon:</strong>}
                {isEditMode ? (
                  <TextField
                    size="small"
                    name="cepTelefon"
                    value={formData.cepTelefon ??""}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    onFocus={handleFocus}
                    label="Telefon"
                    fullWidth
                    helperText={
                      errors.cepTelefon
                        ? "Lütfen geçerli bir telefon girin. Örnek:531***9145"
                        : ""
                    }
                    error={errors.cepTelefon}
                    inputProps={{
                      maxLength: 10,
                    }}
                  />
                ) : (
                  formData.cepTelefon !=null ? formData.cepTelefon.replace(
                    /(\d{3})(\d{3})(\d{4})/,
                    "$1 $2 $3"
                  ):""
                )}
              </li>
              <li className="list-group-item">
                {isEditMode ? null : <strong className="me-2">E-Posta:</strong>}
                {isEditMode ? (
                  <TextField
                    size="small"
                    name="ePosta"
                    error={errors.ePosta}
                    value={formData.ePosta}
                    onChange={handleInputChange}
                    label="E-Posta"
                    fullWidth
                  />
                ) : (
                  formData.ePosta
                )}
              </li>
              {
                isAdminEdit && SessionStorageService.getUserInfo().rol === "ADMIN" && (
                  <li className="list-group-item">
                    {isEditMode ? null : <strong className="me-2">Rol:</strong>}
                    {isEditMode ? (
                      <TextField
                        select
                        size="small"
                        name="rol"
                        value={formData.rol}
                        onChange={handleInputChange}
                        label="Rol"
                        fullWidth
                      >
                        <MenuItem value="ADMIN">Admin</MenuItem>
                        <MenuItem value="PERSONEL">Personel</MenuItem>
                        <MenuItem value="UYE">Üye</MenuItem>
                      </TextField>
                    ) : (
                      formData.rol
                    )}
                  </li>
                )

              }

              <li className="list-group-item">
                {isEditMode ? null : (
                  <strong className="me-2">Kan Grubu:</strong>
                )}
                {isEditMode ? (
                  <TextField
                    select
                    size="small"
                    name="kanGrubu"
                    value={formData.kanGrubu}
                    defaultValue={""}
                    onChange={handleInputChange}
                    label="Kan Grubu"
                    fullWidth
                  >
                    <MenuItem selected value="">Belirsiz</MenuItem>
                    <MenuItem value="A+">A+</MenuItem>
                    <MenuItem value="A-">A-</MenuItem>
                    <MenuItem value="B+">B+</MenuItem>
                    <MenuItem value="B-">B-</MenuItem>
                    <MenuItem value="AB+">AB+</MenuItem>
                    <MenuItem value="AB-">AB-</MenuItem>
                    <MenuItem value="O+">O+</MenuItem>
                    <MenuItem value="O-">O-</MenuItem>
                  </TextField>
                ) : formData.kanGrubu != null ? (
                  formData.kanGrubu
                ) : (
                  "-"
                )}
              </li>
            </ul>
          </div>

          {/* Adres Bilgileri */}
          <div className="col-md-6">
            <h5 className="fw-bold mb-3">Adres Bilgileri</h5>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">
                {isEditMode ? null : <strong className="me-2">İl/İlçe:</strong>}
                {isEditMode ? (
                  <TextField
                    select
                    label="İl/İlçe:"
                    size="small"
                    name="ilIlceKodu"
                    value={formData.ilIlceKodu}
                    onChange={(e) => {
                      const newIlIlceKodu = e.target.value;
                      setFormData((prevData) => ({
                        ...prevData,
                        ilIlceKodu: newIlIlceKodu,
                        mahalleKodu: "",
                        mahalleAdi: "",
                        caddeSokakKodu: "",
                        caddeAdi: "",
                      }));
                    }}
                    fullWidth
                    disabled={!isEditMode}
                    error={errors.ilIlceKodu}
                  >
                    <MenuItem value={""}>{"Seçiniz"}</MenuItem>
                    {ilIlceList.map((item: any) => (
                      <MenuItem key={item.ilIlceKodu} value={item.ilIlceKodu}>
                        {item.ilIlceAdi}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : (
                  // Güvenli şekilde il/ilçe adı erişimi
                  ilIlceList.find((item: any) => String(formData.ilIlceKodu) === String(item.ilIlceKodu))?.ilIlceAdi || "Seçim yapılmadı"
                )}

              </li>
              {
                secilenIlIlce===ilIlceKodu?<>
                  <li className="list-group-item">
                    {isEditMode ? null : <strong className="me-2">Mahalle:</strong>}
                    {isEditMode ? (
                      <TextField
                        select
                        label="Mahalle"
                        size="small"
                        name="mahalleKodu"
                        value={formData.mahalleKodu}
                        onChange={(e) => {
                          const selectedKodu = e.target.value;
                          const matchedMahalle:any = mahalleList.find(
                            (m: any) => m.mahalleKodu === selectedKodu
                          );
                          setFormData((prevData) => ({
                            ...prevData,
                            mahalleKodu: selectedKodu,
                            mahalleAdi: matchedMahalle ? matchedMahalle.mahalleAdi : "",
                          }));
                        }}
                        fullWidth
                        disabled={!isEditMode}
                        error={errors.mahalleKodu}
                      >
                        <MenuItem value={""}>{"Seçiniz"}</MenuItem>
                        {mahalleList.map((item: any) => (
                          <MenuItem key={item.mahalleKodu} value={item.mahalleKodu}>
                            {item.mahalleAdi}
                          </MenuItem>
                        ))}
                      </TextField>
                    ) : (
                      formData.mahalleAdi
                )}
                  </li>
                  <li className="list-group-item">
                    {isEditMode ? null : (
                      <strong className="me-2">Cadde/Sokak:</strong>
                    )}
                    {isEditMode ? (
                      <TextField
                        select
                        size="small"
                        label="Cadde/Sokak"
                        name="caddeSokakKodu"
                        error={errors.caddeSokakKodu}
                        value={formData.caddeSokakKodu || ""} // Eğer null/undefined ise boş string ata
                        onChange={(e) => {
                          const selectedKodu = e.target.value;
                          const matchedCadde:any = caddeSokakList.find(
                            (c: any) => c.caddeSokakKodu === selectedKodu
                          );
                          setFormData((prevData) => ({
                            ...prevData,
                            caddeSokakKodu: selectedKodu,
                            caddeAdi: matchedCadde ? matchedCadde.caddeSokakAdi : "",
                          }));
                        }}
                        fullWidth
                        disabled={!isEditMode}
                      >
                        <MenuItem value={""}>{"Seçiniz"}</MenuItem>
                        {caddeSokakList.map((item: any) => (
                          <MenuItem
                            key={item.caddeSokakKodu}
                            value={item.caddeSokakKodu}
                          >
                            {item.caddeSokakAdi}
                          </MenuItem>
                        ))}
                      </TextField>
                    ) : (
                      formData.caddeAdi
                    )}
                  </li>

                </>:<>
                  <li className="list-group-item">
                    {isEditMode ? null : <strong className="me-2">Mahalle Adı:</strong>}
                    {isEditMode ? (
                      <TextField
                        size="small"
                        name="mahalleAdi"
                        error={errors.mahalleAdi}
                        value={formData.mahalleAdi}
                        onChange={handleInputChange}
                        label="Mahalle Adı"
                        fullWidth
                      />
                    ) : (
                      formData.mahalleAdi
                    )}
                  </li>
                  <li className="list-group-item">
                    {isEditMode ? null : <strong className="me-2">Cadde Adı:</strong>}
                    {isEditMode ? (
                      <TextField
                        size="small"
                        name="caddeAdi"
                        error={errors.caddeAdi}
                        value={formData.caddeAdi}
                        onChange={handleInputChange}
                        label="Cadde Adı"
                        fullWidth
                      />
                    ) : (
                      formData.caddeAdi
                    )}
                  </li>

                </>
              }

              <li className="list-group-item">
                {isEditMode ? null : <strong className="me-2">Kapı No:</strong>}
                {isEditMode ? (
                  <TextField
                    size="small"
                    name="kapiNo"
                    error={errors.kapiNo}
                    value={formData.kapiNo}
                    onChange={handleInputChange}
                    label="Kapı No"
                    fullWidth
                  />
                ) : (
                  formData.kapiNo
                )}
              </li>
              <li className="list-group-item">
                {isEditMode ? null : (
                  <strong className="me-2">Daire No:</strong>
                )}
                {isEditMode ? (
                  <TextField
                    size="small"
                    name="daireNo"
                    error={errors.daireNo}
                    value={formData.daireNo}
                    onChange={handleInputChange}
                    label="Daire No"
                    fullWidth
                  />
                ) : (
                  formData.daireNo
                )}
              </li>
              <li className="list-group-item">
                {isEditMode ? null : (
                  <strong className="me-2">Apartman Adı:</strong>
                )}
                {isEditMode ? (
                  <TextField
                    size="small"
                    name="siteApartmanAdi"
                    value={formData.siteApartmanAdi}
                    onChange={handleInputChange}
                    label="Apartman Adı"
                    fullWidth
                  />
                ) : formData.siteApartmanAdi != null ? (
                  formData.siteApartmanAdi
                ) : (
                  "-"
                )}
              </li>
              <li className="list-group-item">
                {isEditMode ? null : <strong className="me-2">Blok No:</strong>}
                {isEditMode ? (
                  <TextField
                    size="small"
                    name="blokNo"
                    value={formData.blokNo}
                    onChange={handleInputChange}
                    label="Blok No"
                    fullWidth
                  />
                ) : formData.blokNo != null ? (
                  formData.blokNo
                ) : (
                  "-"
                )}
              </li>
              <li className="list-group-item">
                {isEditMode ? null : (
                  <strong className="me-2">Posta Kodu:</strong>
                )}
                {isEditMode ? (
                  <TextField
                    size="small"
                    name="postaKodu"
                    value={formData.postaKodu==0?"":formData.postaKodu}
                    onChange={handleInputChange}
                    label="Posta Kodu"
                    fullWidth
                  />
                ) : formData.postaKodu != null ? (
                  formData.postaKodu
                ) : (
                  "-"
                )}
              </li>
            </ul>
          </div>
        </div>
      </div>
      {smsPopupOpen && (
        <TcTelefonSmsControlPopupOnPage
          tcKimlikNo={isAdminEdit ? adminUser?.tcKimlikNo : user?.kullaniciKodu}
          cepTelefonu={formData.cepTelefon}
          onClose={() => setSmsPopupOpen(false)}
          onVerificationComplete={(isVerified: any) => {
            setSmsPopupOpen(false); // Popup'ı kapat
            if (isVerified) {
              saveYeniUyelik(formData); // Doğrulama başarılıysa kaydet
            } else {
              toast.error("Telefon doğrulama başarısız. Kayıt yapılmadı.");
            }
          }}
        />
      )}
    </div>
  );
};
